import { Endorsement } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum EndorsementActionTypes {
  LoadForQuoteSuccess = '[Endorsements API] Load All For Quote Success',
  LoadForQuoteFailure = '[Endorsements API] Load All For Quote Failure',
}

export const EndorsementApiActions = {
  loadForQuoteSuccess: createAction(
    EndorsementActionTypes.LoadForQuoteSuccess,
    props<{ endorsements: Endorsement[] }>()
  ),
  loadForQuoteFailure: createAction(
    EndorsementActionTypes.LoadForQuoteFailure,
    props<{ error: any }>()
  ),
};
